import React from 'react';

import cls from './Spacer.module.scss';

const Spacer = ({ size = 0 }) => (
  <div className={cls.wrapper} style={{ '--spacer-size': `${size}px` }} />
);

export default Spacer;
